import { ShiftModalComponentMap } from 'modals/ShiftModal/ShiftModal.constants';
import { useShiftModalUIContext } from 'modals/ShiftModal/ShiftModal.ui.context';
import { ShiftModalTemplate } from 'modals/ShiftModal/ShiftModalTemplate';
import {
  EditViewRenderer,
  SendToAgenciesViewRenderer,
  AuditTrailViewRenderer,
  AwardTeamMemberViewRender,
} from 'modals/ShiftModal/src/views';
import { AssignToAgencyTeamMemberViewRenderer } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/AssignToAgencyTeamMemberView';
import { FC, useMemo } from 'react';

export const ShiftModalComponent: FC = () => {
  const { shiftModalActiveModalView } = useShiftModalUIContext();

  const Component = useMemo(() => {
    return {
      ...ShiftModalComponentMap,
      EditView: EditViewRenderer,
      NotifyTeamMember: EditViewRenderer,
      ReasonForEdits: EditViewRenderer,
      EditingReasonAndNotifyView: EditViewRenderer,
      ConfirmEditsView: EditViewRenderer,
      PublishEditsWarningView: EditViewRenderer,
      PreRequestOptionsView: SendToAgenciesViewRenderer,
      SendToAgenciesSummaryView: SendToAgenciesViewRenderer,
      RequestTeamMemberView: SendToAgenciesViewRenderer,
      PostRequestOptionsView: SendToAgenciesViewRenderer,
      SelectAgenciesView: SendToAgenciesViewRenderer,
      SendToSelectedAgenciesSummaryView: SendToAgenciesViewRenderer,
      AssignToAgencyTeamMemberView: AssignToAgencyTeamMemberViewRenderer,
      AssignToAgencyTeamMemberSummaryView: AssignToAgencyTeamMemberViewRenderer,
      TeamMemberUnavailableView: AssignToAgencyTeamMemberViewRenderer,
      ShiftUnavailableView: AssignToAgencyTeamMemberViewRenderer,
      AuditTrailViewRenderer: AuditTrailViewRenderer,
      AwardTeamMemberView: AwardTeamMemberViewRender,
      AwardUnavailableView: AwardTeamMemberViewRender,
      ShiftConflictView: AwardTeamMemberViewRender,
      AwardShiftBlockView: AwardTeamMemberViewRender,
    }[shiftModalActiveModalView];
  }, [shiftModalActiveModalView]);
  return (
    <ShiftModalTemplate>
      <Component />
    </ShiftModalTemplate>
  );
};
